/* istanbul ignore file */
import React, { useCallback, useState } from 'react';
import { CreateForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import useProcessInstanceUpdatingService from 'domain/gpo/cockpit/instance/Show/shared/processInstanceUpdatingService';
import { useProcessInstanceId, useProcessInstanceUrl } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import TerminateProcessForm from 'domain/gpo/cockpit/instance/Show/shared/TerminateProcessInstanceForm';

const MESSAGE_CONTEXT = 'TerminateProcessModalForm';

interface TerminateProcessModalFormProps {
  closeModal: () => void;
}

const TerminateProcessModalForm = ({ closeModal }: TerminateProcessModalFormProps) => {
  const processInstanceId = useProcessInstanceId();
  const { getSingleEntityUrl } = useProcessInstanceUrl();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const { terminate, getValidationSchemaToTerminate } = useProcessInstanceUpdatingService();

  const closeForm = useCallback(() => {
    setIsModalOpen(false);
    closeModal();
  }, [setIsModalOpen, closeModal]);

  return (
    <CreateForm
      submitFormFunc={terminate}
      messageContext={MESSAGE_CONTEXT}
      getValidationSchemaFunc={getValidationSchemaToTerminate}
      initialData={{
        instanceId: processInstanceId,
        reason: null,
      }}
      afterSubmit={{
        redirect: getSingleEntityUrl(processInstanceId),
        message: 'You are awesome! The Process Instance ID has been successfully terminated.',
      }}
    >
      <Modal
        key="modal-not-strict"
        modalSize="sm"
        backdrop="static"
        keyboard={false}
        isOpen={isModalOpen}
        hasCancelButton={false}
        title={`Terminate process: ${processInstanceId}`}
        onToggle={closeForm}
      >
        <TerminateProcessForm handleCancelClick={closeForm} />
      </Modal>
    </CreateForm>
  );
};

export default TerminateProcessModalForm;
